import { groq } from 'next-sanity';
import { z } from 'zod';

export const SanityLink = z.object({
  _type: z.enum(['internalLink', 'externalLink']),
  _key: z.string().optional().nullable(),
  title: z.string(),
  href: z.string(),
  target: z.literal('_blank').optional(),
});
export type SanityLink = z.infer<typeof SanityLink>;

export const link = groq`{
  _type,
  defined(_key) =>{
    _key,
  },
  _type == 'internalLink' => {
    defined(title) => {
      title,
    },
    !defined(title) => {
      'title': coalesce(reference->title, reference->titleOverride, reference->parent->title),
    },
    ...(reference-> {
      _type == 'page' => {
        'href': select(
          *[_type == 'site'][0].homepage->slug.current == slug.current => '/' + select(^.anchorId != null => '#' + ^.anchorId, ''),
          '/' + slug.current + select(^.anchorId != null => '#' + ^.anchorId, ''),
        ),
      },
      _type == 'blog' => {
        'href': '/blog' + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'caseStudies' => {
        'href': '/case-studies' + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'post' => {
        'href': '/blog/' + slug.current + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'caseStudy' => {
        'href': '/case-studies/' + slug.current + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'author' => {
        'href': '/blog/author/' + slug.current + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'resources' => {
        'href': '/resources' + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'resource' => {
        'href': '/resources/' + slug.current + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'events' => {
        'href': '/events' + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'event' => {
        'href': '/events/' + slug.current + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'blogCategory' => {
        'href': '/blog/categories/' + slug.current + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'resourceCategory' => {
        'href': '/resources/categories/' + slug.current + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'glossaryTerm' => {
        'href': '/glossary/' + slug.current + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'glossary' => {
        'href': '/glossary' + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'integration' => {
        'href': '/integrations/' + slug.current + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'integrations' => {
        'href': '/integrations' + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'legalDocument' => {
        'href': '/legal/' + slug.current + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'legalDocumentVersion' => {
        'href': '/legal/' + parent->slug.current + '/' + string(effectiveDate) + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'legalIndex' => {
        'href': '/legal' + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
      _type == 'accountPage' => {
        'href': '/for/' + campaign->slug.current + '/' + slug.current + select(^.anchorId != null => '#' + ^.anchorId, ''),
      },
    }),
  },
  _type == 'externalLink' => {
    title,
    'href': url,
  },
  newTab => {
    'target': '_blank',
  },
}`;
